import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from '../components/ErrorBoundary';
import Layout from '../Layout';

const RoutesWithErorrBoundary = ({ routeList }) => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {routeList?.map(({ path, component: Component, ...rest }) => {
          if (rest?.subRoutes) {
            return (
              <Route
                key={rest?.name}
                path={path}
                element={
                  <ErrorBoundary>
                    <Suspense fallback={null}>
                      <Component {...rest} />
                    </Suspense>
                  </ErrorBoundary>
                }
              >
                {rest?.subRoutes?.map(({ path, component: SubrouteComponent, ...rest }) => {
                  return (
                    <Route
                      key={rest?.name}
                      path={path}
                      element={
                        <Suspense fallback={null}>
                          <SubrouteComponent {...rest} />
                        </Suspense>
                      }
                    />
                  );
                })}
              </Route>
            );
          } else {
            return (
              <Route
                key={rest.name}
                path={path}
                element={
                  <ErrorBoundary>
                    <Suspense fallback={null}>
                      <Component {...rest} />
                    </Suspense>
                  </ErrorBoundary>
                }
              />
            );
          }
        })}
        <Route path="*" element={<div>Page Not Found</div>} />
      </Route>
    </Routes>
  );
};

export default RoutesWithErorrBoundary;
